import { FC } from 'react';
import { Text } from '@concepta/react-material-ui';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ProductInterface } from 'ks-common';
import DOMPurify from 'dompurify';
import AccessoryBulletList from 'app/components/AccessoryBulletList';
import PromoCallout from 'app/components/PromoCallout';
import { getProductContent } from 'app/constants/productContent';
import { getSnackTrayPromo } from 'app/constants/snackTrayPromo';

interface Props {
  product?: ProductInterface;
}

const StrollerDescription: FC<Props> = ({ product }) => {
  const content = getProductContent(product?.ProductID);
  const snackTrayPromo = getSnackTrayPromo(product?.ProductID);

  if (content) {
    return (
      <Box
        sx={{
          fontSize: '16px',
          fontFamily: 'Roboto, sans-serif',
          color: 'grey.800',
        }}
      >
        {content.description.map((paragraph, index) => (
          <Typography
            key={index}
            sx={{
              fontSize: 'inherit',
              fontFamily: 'inherit',
              color: 'inherit',
              mb: '12px',
            }}
          >
            {paragraph}
          </Typography>
        ))}
        {content.bullets && content.bullets.length > 0 && (
          <>
            <Typography
              sx={{
                fontSize: 'inherit',
                fontFamily: 'inherit',
                color: 'inherit',
                fontWeight: 700,
                mb: '4px',
              }}
            >
              Accessories:
            </Typography>
            {snackTrayPromo && (
              <Box sx={{ mb: '8px' }}>
                <PromoCallout
                  title={snackTrayPromo.title}
                  description={snackTrayPromo.description}
                  note={snackTrayPromo.note}
                />
              </Box>
            )}
            <AccessoryBulletList bullets={content.bullets} />
          </>
        )}
      </Box>
    );
  }

  return (
    <Text
      fontSize={16}
      fontWeight={400}
      fontFamily="Roboto, sans-serif"
      color="grey.800"
    >
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(product?.ProductDescription || ''),
        }}
      />
    </Text>
  );
};

export default StrollerDescription;
